import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "showLabel", "hideLabel", "trigger"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    const isHidden = this.contentTarget.classList.contains("hidden")

    if (this.hasShowLabelTarget && this.hasHideLabelTarget) {
      this.showLabelTarget.classList.toggle("hidden", !isHidden)
      this.hideLabelTarget.classList.toggle("hidden", isHidden)
    }

    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", !isHidden)
    }

    if (!isHidden) {
      requestAnimationFrame(() => {
        const scrollTarget = this.element.closest("[class*='rounded-']") || this.element
        scrollTarget.scrollIntoView({ behavior: "smooth", block: "end" })
      })
    }
  }
}
